import { useState } from 'react'
import styled, { CSSObject } from '@emotion/styled'
import ExpandableDiv from '../ExpandableContainer/ExpandableDiv'
import ToggleSwitchLabel from './ToggleSwitchLabel'

type Props = {
  children: React.ReactNode
  label: string
  switchName: string
  onToggle: (isChecked: boolean) => void
  defaultChecked?: boolean
}

const ToggleSwitchSection = ({
  children,
  label,
  switchName,
  onToggle,
  defaultChecked = false
}: Props) => {
  const [isSectionOpen, setIsSectionOpen] = useState<boolean>(defaultChecked)

  const handleToggle = (isChecked: boolean) => {
    setIsSectionOpen(isChecked)
    onToggle(isChecked)
  }

  return (
    <Container>
      <ToggleSwitchLabel
        label={label}
        switchName={switchName}
        onToggle={handleToggle}
        defaultChecked={isSectionOpen}
      />
      <ExpandableDiv isExpanded={isSectionOpen} collapsedHeight={0}>
        {children}
      </ExpandableDiv>
    </Container>
  )
}

const Container = styled.div(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column'
  })
)

export default ToggleSwitchSection
